import { styled } from "~/common/mui";
import { Card } from "~/features/configurator/Linear/components/Card";

export const SegmentRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(2),
  "& p": {
    margin: 0,
  },
}));

export const SegmentInputSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  "& p": {
    margin: 0,
  },
}));

export const SegmentImageCard = styled(Card)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const SegmentImage = styled("img")({
  aspectRatio: "322 / 80",
});

export const SegmentTitleSection = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const SegmentTitle = styled("div")(({ theme }) => ({
  ...theme.typography.bodyLarge,
}));

export const SegmentFieldTitle = styled("p")(({ theme }) => ({
  ...theme.typography.bodyLarge,
  marginBottom: `-${theme.spacing(0.5)}`,
}));

export const SegmentAlarSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(1),
}));

export const SegmentAlarRow = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  "& > *": {
    flex: 1,
  },
}));

export const SegmentAlarDescription = styled("p")(({ theme }) => ({
  margin: 0,
  ...theme.typography.bodyLarge,
}));

export const SegmentTileTile = styled("p")(({ theme }) => ({
  ...theme.typography.bodyLarge,
}));

export const SegmentFullWidth = styled("div")(({ theme }) => ({
  "&&": {
    marginLeft: `-${theme.spacing(2)}`,
    marginRight: `-${theme.spacing(2)}`,
  },
}));
